import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { TypeEquipement } from 'app/models/typeEquipement.model';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TypeEquipementService {

  private API_URL= environment.API_URL;
  private MODEL_URL='types-equipements';

  constructor(private http: HttpClient) { }

  getTypesEquipements(): Observable<TypeEquipement[]> {
    return this.http.get<TypeEquipement[]>(this.API_URL + this.MODEL_URL);
  }

  store(typeEquipement: TypeEquipement): Observable<TypeEquipement>{
    return this.http.post<TypeEquipement>(this.API_URL + this.MODEL_URL, typeEquipement).pipe(
      catchError(err => throwError(err))
    );
  }
}
